import { Button, Datagrid, FunctionField, List, SimpleList, TextField, TextInput } from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import { CURRICULUMS, MOBILE_BREAKPOINT, MODULES, StudentServicePath } from "utils/constants";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import CreateModuleButton from "./CreateModuleButton";
import { EmptyWithAction } from "server/components";
import SecuredComponent from "server/security/SecuredComponent";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const CurrriculumModules = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const curriculumName = location.state?.curriculumName;
  const { id } = useParams();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const canCreate = checkPermission(getPermissions(), permissions.canManageCurriculumModules);

  const filters = [
    <TextInput
      label="Наименование"
      source="name"
      alwaysOn
    />,
  ];

  return (
    <>
      <BackButtonToolbar />
      <List
        resource={`${StudentServicePath}${CURRICULUMS}/${id}/${MODULES}`}
        title={`Модули за учебен план: ${curriculumName}`}
        filters={filters}
        empty={
          <EmptyWithAction message="Няма намерени резултати.">
            <CreateModuleButton
              canCreate={canCreate}
              id={id}
              curriculumName={curriculumName}
            />
          </EmptyWithAction>
        }
        exporter={false}
        actions={
          <CreateModuleButton
            id={id}
            canCreate={canCreate}
            curriculumName={curriculumName}
          />
        }
      >
        {isMobile ? (
          <SimpleList
            linkType={false}
            sx={settings.style.mobileList}
            primaryText={() => (
              <div>
                <MobileListRow fields={[{ label: "Наименование (BG)", value: <TextField source="nameBg" /> }]} />
                <MobileListRow fields={[{ label: "Наименование (EN)", value: <TextField source="nameEn" /> }]} />
              </div>
            )}
            secondaryText={record => (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent permission={permissions.canManageCurriculumModules}>
                  <Button
                    label="Редакция"
                    startIcon={<EditIcon />}
                    onClick={() =>
                      navigate(`/${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/edit`, {
                        state: { module: record, curriculumName },
                      })
                    }
                  />
                </SecuredComponent>
                <SecuredComponent permission={permissions.canPreviewCurriculumModules}>
                  <Button
                    label="Детайли"
                    startIcon={<VisibilityIcon />}
                    onClick={() =>
                      navigate(`/${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/show`, {
                        state: { module: record, curriculumName },
                      })
                    }
                  />
                </SecuredComponent>
              </div>
            )}
          />
        ) : (
          <Datagrid
            bulkActionButtons={false}
            rowClick={false}
            sx={{
              "& .RaDatagrid-headerCell": {
                textAlign: "left",
              },
            }}
          >
            <TextField
              source="nameBg"
              label="Наименование (BG)"
            />
            <TextField
              source="nameEn"
              label="Наименование (EN)"
            />
            <SecuredComponent permission={permissions.canManageCurriculumModules}>
              <FunctionField
                render={rec => (
                  <Button
                    label="Редакция"
                    startIcon={<EditIcon />}
                    onClick={() =>
                      navigate(`/${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/edit`, {
                        state: { module: rec, curriculumName },
                      })
                    }
                  />
                )}
              />
            </SecuredComponent>
            <SecuredComponent permission={permissions.canPreviewCurriculumModules}>
              <FunctionField
                render={rec => (
                  <Button
                    label="Детайли"
                    startIcon={<VisibilityIcon />}
                    onClick={() =>
                      navigate(`/${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/show`, {
                        state: { module: rec, curriculumName },
                      })
                    }
                  />
                )}
              />
            </SecuredComponent>
          </Datagrid>
        )}
      </List>
    </>
  );
};

export default CurrriculumModules;
